<template>
  <div>
    <div class="p-3 card mb-3">
      <fccClassificacaoBusca
        :lista-apresentacao-das-classificacoes="listaApresentacaoDasClassificacoes"
        @buscar="buscar"
      />
    </div>

    <div class="p-3 card mb-3" v-if="listaClassificoes.length > 0 || listaAlteracoes.length > 0">
      <fccClassificacaoTabela
        :lista-classificacoes="listaClassificoes"
        @importar="importar"
        v-if="listaClassificoes.length > 0"
      />
      <fccClassificacaoAlteracoes
        :lista-alteracoes="listaAlteracoes"
        @deletar="deletar"
        v-if="listaAlteracoes.length > 0"
      />
    </div>
    <fccLocalDeProvaStatus :etapa="etapa" />
  </div>
</template>

<script>
import axios from 'axios'
import store from '../../../../store'
import fccClassificacaoBusca from './fccClassificacaoBusca.vue'
import fccClassificacaoTabela from './fccClassificacaoTabela.vue'
import fccClassificacaoAlteracoes from './fccClassificacaoAlteracoes.vue'
import fccLocalDeProvaStatus from '../fccLocalDeProvaStatus.vue'
import { TP_ETAPA } from '../constantes'

export default {
  components: {
    fccClassificacaoBusca,
    fccClassificacaoTabela,
    fccClassificacaoAlteracoes,
    fccLocalDeProvaStatus
  },
  data() {
    return {
      listaClassificoes: [],
      listaAlteracoes: [],
      tpApresentacao: '',
      rotulo: '',
      listaApresentacaoDasClassificacoes: []
    }
  },
  computed: {
    configuracao() {
      return store.state.localDeProva.configuracao
    },
    etapa() {
      return TP_ETAPA.CLASSIFICACAO
    }
  },
  created() {
    this.carregaTexto(this.codeMensagem('C01'))
    this.listarApresentacaoDasClassificacoes().then(() =>
      this.listarAlteracoes().then(this.carregaTexto)
    )
  },
  methods: {
    listarApresentacaoDasClassificacoes() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva + `ApresentacaoClassificacao/ListaTipoClassificacao`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaApresentacaoDasClassificacoes = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    buscar(tpApresentacao, rotulo) {
      this.tpApresentacao = tpApresentacao
      this.rotulo = rotulo

      this.carregaTexto(this.codeMensagem('C01'))
      this.listarClassificacoes().then(this.carregaTexto)
    },
    listarClassificacoes() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `ApresentacaoClassificacao/ListaApresentacaoClassificacao/${this.configuracao.idlocalconfig}/${this.tpApresentacao}/${this.rotulo}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaClassificoes = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    importar(items) {
      const body = items.map((item) => ({
        idLocalClassificado: 0,
        tpApresentacaoClassificacao: item.tpapresentacao,
        idLocalConfig: this.configuracao.idlocalconfig,
        codCidClass: item.codigoclass,
        cidadeClassificacao: item.opcaoclass,
        rotulo: item.rotulo,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          store.state.baseUrlLocalDeProva +
            `ApresentacaoClassificacao/InsereApresentacaoClassificacao`,
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() =>
          this.listarClassificacoes().then(() => this.listarAlteracoes().then(this.carregaTexto))
        )
        .catch(this.setErrorSystem)
    },
    listarAlteracoes() {
      return new Promise((resolve) => {
        axios
          .get(
            store.state.baseUrlLocalDeProva +
              `ApresentacaoClassificacao/ListaTipoApresentacaoClassificacaoCadastrado/${this.configuracao.idlocalconfig}`,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(({ data }) => {
            this.listaAlteracoes = data
            resolve()
          })
          .catch(this.setErrorSystem)
      })
    },
    deletar(items) {
      const data = items.map((item) => ({
        idLocalConfig: item.idlocalclassificado,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }))

      this.callConfirm(`Tem certeza que deseja excluir?`, '').then(() => {
        const { headers } = this.dadosLoginSession.fccTokenHeaders

        this.carregaTexto(this.codeMensagem('C01'))
        axios
          .delete(
            store.state.baseUrlLocalDeProva +
              `ApresentacaoClassificacao/ExcluiTipoApresentacaoClassificacaoCadastrado`,
            {
              data,
              headers
            }
          )
          .then(() => {
            this.listarAlteracoes().then(() => {
              if (this.listaClassificoes.length > 0)
                this.listarClassificacoes().then(this.carregaTexto)
              else this.carregaTexto()
            })
          })
          .catch(this.setErrorSystem)
      })
    }
  }
}
</script>